exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dyna-cms-viewer {\n  color: black;\n  background-color: #fbfbfb;\n  padding: 16px;\n}\n", ""]);

// exports
